import clsx from 'clsx';

export function Divider({ className, ...props }: React.ComponentPropsWithoutRef<'hr'>) {
  return (
    <hr
      role="presentation"
      {...props}
      className={clsx(className, 'w-full border-t border-borderPrimary')}
    />
  );
}
